import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get saleOrderBranch
export const getSaleOrderBranch = createAsyncThunk(
  "saleOrderBranch/getSaleOrderBranch",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getSaleOrderBranch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all saleOrderBranch
export const getAllSaleOrderBranch = createAsyncThunk(
  "saleOrderBranch/getAllSaleOrderBranch",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllSaleOrderBranch();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("saleOrderBranch/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("saleOrderBranch/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "saleOrderBranch/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageSaleOrderBranch({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get SaleOrderBranch AdditionalCharge List
export const getSaleOrderBranchAdditionalChargeList = createAsyncThunk(
  "saleOrderBranch/getSaleOrderBranchAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleOrderBranchAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getSaleOrderBranchById = createAsyncThunk(
  "saleOrderBranch/getSaleOrderBranchById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleOrderBranchById(id);

      if (data?.data.saleOrderDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.saleOrderDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, saleOrderDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create saleOrderBranch
export const createSaleOrderBranch = createAsyncThunk(
  "saleOrderBranch/createSaleOrderBranch",
  async (createData, { rejectWithValue }) => {
    const {
      salesOrderMain,
      saleOrderBranchDetails,
      salesOrderMainAdditionalChargeCost,
      salesOrderMainPartyDetails,
      salesOrderMainVehicleDetail,
      // invoiceNo,
      // refNo,
      voucherDateBs,
      voucherDate,
      narration,
      branch,
      termsOfDelivery,
      termOfPayment,
      deliveryDocNo,
      otherReferences,
      destination,
      salesOrderRequest,
      partyAccount,
      discountAmount,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        salesOrderMain,
        saleOrderBranchDetails,
        salesOrderMainAdditionalChargeCost,
        salesOrderMainPartyDetails,
        salesOrderMainVehicleDetail,
        // invoiceNo,
        // refNo,
        voucherDateBs,
        voucherDate,

        branch,
        termsOfDelivery,
        termOfPayment,
        deliveryDocNo,
        otherReferences,
        destination,
        narration,
        salesOrderRequest,
        partyAccount,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      console.log("hello");
      const { data } = await API.createSaleOrderBranch(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSaleOrderBranch = createAsyncThunk(
  "saleOrderBranch/updateSaleOrderBranch",
  async (params, { rejectWithValue }) => {
    const { id, submitData } = params;
    const {
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      voucherDateBs,
      voucherDate,
      branch,
      status,
      salesOrderMainPartyDetails,
      salesOrderMainVehicleDetail,
      // yo field name mileko thiyena, fix bhayo hai
      documentsAttach,
      // refVoucher,
      saleOrderBranchDetails,
      salesOrderMainAdditionalChargeCost,
      discountAmount,
      grandTotal,
      vatAmount,
    } = submitData;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        isFromHo,
        requiredDateAd,
        branch,
        status,
        salesOrderMainPartyDetails,
        salesOrderMainVehicleDetail,
        voucherDateBs,
        voucherDate,
        // refVoucher,
        saleOrderBranchDetails,
        salesOrderMainAdditionalChargeCost,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.updateSaleOrderBranch(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//converting to Sale Invoice From Sales Order
export const convertToSaleInvoice = createAsyncThunk(
  "saleOrderBranch/convertToSaleInvoice",
  async (createData, { rejectWithValue }) => {
    const {
      partyAccount,
      saleInvoiceDetails,
      voucherDateBs,
      voucherDate,
      branch,
      salesOrderMain,
      salesInvoiceMainAdditionalChargeCost,
      saleInvoiceMainPartyDetails,
      saleInvoiceMainVehicleDetail,
      narration,
      discountAmount,
      grandTotal,

      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        partyAccount,
        saleInvoiceDetails,
        voucherDateBs,
        voucherDate,
        branch,
        salesOrderMain,
        salesInvoiceMainAdditionalChargeCost,
        saleInvoiceMainPartyDetails,
        saleInvoiceMainVehicleDetail,
        narration,
        discountAmount,
        grandTotal,
        vatAmount,
      });

      const { data } = await API.convertToSaleInvoice(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// handle search
export const handleSearch = createAsyncThunk(
  "saleOrderBranch/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
